"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[601],{

/***/ 5601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Garantie": function() { return /* binding */ Garantie; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2903);
/* harmony import */ var _silvertours_front_legacy_shared__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6522);
/* harmony import */ var _CarigamiGarantie_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5650);



var Garantie = function Garantie() {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_CarigamiGarantie_styles__WEBPACK_IMPORTED_MODULE_1__/* .GarantieWrapper */ .UR, {
        href: "/conditions-garantie.htm",
        title: "Garantie meilleur prix",
        target: "_blank",
        rel: "noopener noreferrer",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_silvertours_front_legacy_shared__WEBPACK_IMPORTED_MODULE_0__/* .UiLegacy.PixelIcon */ .ws.PixelIcon, {
            name: "garantie",
            label: "Garantie meilleur prix"
        })
    });
};



/***/ })

}]);